module.exports = __webpack_public_path__ + "img/dados-pessoais.abc23b73.svg";